<script setup lang="ts">
import type { DialogName } from '@/stores/useDialogStore';

import SecondarySideBarMenuVListItem from '@/components/items/SecondarySideBarMenuVListItem.vue';
import { useDialogStore } from '@/stores/useDialogStore';
import { btnLogout } from '@/helpers/logouts';

import listItemStyles from '@/styles/listItem.module.scss';

async function handleConfirmClick(): Promise<void> {
  return btnLogout();
}

function onOpenConfirmDialog() {
  const dialogName: DialogName = 'logout';
  dialogStore.open(dialogName, {
    confirm: handleConfirmClick,
  });
}

const dialogStore = useDialogStore();
</script>

<template>
  <SecondarySideBarMenuVListItem
    :class="listItemStyles.logoutVListItem"
    data-testid="logoutVListItem"
    prepend-icon="mdi-logout"
    @click="onOpenConfirmDialog"
  >
    Logout
  </SecondarySideBarMenuVListItem>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
</style>
